module.exports = __webpack_public_path__ + "assets/img/forest-1.3fdcb373.png";